import { Component, OnInit } from '@angular/core';
import { RoutingService } from '@services';
import { TranslateService } from '@ngx-translate/core';
import { InternationalizationService } from '@shared/services/i18n.service';

@Component({
  selector: 'app-how-to-use',
  templateUrl: './how-to-use.component.html',
  styleUrls: ['./how-to-use.component.scss']
})
export class HowToUseComponent implements OnInit {

  public get lang(): string { return this.i18n.lang; }
  constructor(
    public translate: TranslateService,
    public i18n: InternationalizationService,
    public routingService: RoutingService
  ) {
    translate.setDefaultLang(i18n.lang);
  }
  public ngOnInit() { }
}
